import { Type } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkerResult } from 'libs/abc/core/data/src/lib/models/worker.model';

export class WizardExportConfig {
  welcomePage!: WizardExportPage;
  contentPages: WizardExportContentPage[];
  transferObject!: object;
  exportFileNameSchema: string;
  startExportWorker: (transferObject: object) => Observable<WorkerResult>;

  static readonly TimeStamp_Placeholder: string = '{timestamp}';
  constructor() {
    this.welcomePage = new WizardExportPage();
    this.contentPages = new Array<WizardExportContentPage>();
    this.exportFileNameSchema = 'Export_' + WizardExportConfig.TimeStamp_Placeholder + '.xml';
  }
}

export class WizardExportPage {
  title: string;
  description: string;
  constructor() {}
}

export class WizardExportContentPage extends WizardExportPage {
  component: Type<unknown>;
  componentInstance: IWizardExportPageComponent;
  constructor() {
    super();
  }
}

export interface IWizardExportPageComponent {
  transferObject: object;
  readonly isValid: boolean;
  readonly invalidMessage: string;
  onNext(): void;
}
